import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const LastMatchesWidgetAsyncComponent = AsyncComponent(async () => import('./last-matches.widget' /* webpackChunkName: "last-matches.widget" */ ));

export const LastMatchesWidgetAsync = (props) => {
  return <LastMatchesWidgetAsyncComponent {...props}/>
};
